/** @file The §5.9 mount of an item from its handle in its own local frame (bake and runtime equip). */
import type { Handle } from '@pose2d/format/types';
import type { Affine } from '@pose2d/math/types';
import { computeMountTransform } from './computeMountTransform';

/** Module scratch for the y-down handle; never escapes, so a runtime equip allocates nothing. */
const Y_DOWN: { a: [number, number]; b: [number, number] } = { a: [0, 0], b: [0, 0] };

/**
 * out = the similarity carrying `handle`, given in the item's own authored local frame (slot-bone space, y-up: after
 * its region transform with width/height and scale, or its rigid-mesh pixel fit), onto a socket bone: a -> origin,
 * b -> +X, scaled by socketLength / |b - a| when fitLength, otherwise rigid, so the authored size wins (final review
 * C2/C7, ruling b). The compiler bakes it into document-mounted items; runtime equip writes it into pose.slotMount.
 */
export function itemMountTransform(out: Affine, handle: Handle, socketLength: number, fitLength: boolean): Affine {
  // computeMountTransform takes y-down image pixels and flips y itself.
  Y_DOWN.a[0] = handle.a[0];
  Y_DOWN.a[1] = -handle.a[1];
  Y_DOWN.b[0] = handle.b[0];
  Y_DOWN.b[1] = -handle.b[1];
  return computeMountTransform(out, Y_DOWN, socketLength, fitLength);
}
